export default function Termos() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12 py-16 text-slate-300 space-y-6 leading-relaxed">
      <h1 className="font-display text-4xl font-bold text-white">Termos de Uso</h1>
      <p className="text-sm text-slate-400">Última atualização: {new Date().toLocaleDateString("pt-BR")}</p>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">1. Objeto</h2>
        <p>O vixvox é uma plataforma SaaS de canal de denúncia corporativo, oferecida como ferramenta de conformidade à NR-1 (Portaria MTE 1.419/2024) e ISO/IEC 27001.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">2. Plano e cobrança</h2>
        <p>Plano único: R$ 299,00/mês por empresa contratante, com 7 dias de teste grátis. A cobrança é mensal, sem multa por cancelamento.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">3. Responsabilidades da contratante</h2>
        <p>A empresa contratante é responsável por divulgar o canal aos colaboradores, definir política de retenção, atribuir gestores de compliance e garantir apuração isenta das denúncias.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">4. Uso vedado</h2>
        <p>É vedado o uso do canal para denúncias sabidamente falsas, promoção de conteúdo ilícito, discriminatório ou que viole direitos de terceiros.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">5. Disponibilidade</h2>
        <p>Buscamos disponibilidade de 99,5% mensal, com backups criptografados e continuidade de negócio conforme ISO 27001.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white mt-8 mb-3">6. Foro</h2>
        <p>Fica eleito o foro da Comarca de São Paulo/SP para dirimir eventuais controvérsias.</p>
      </section>
    </div>
  );
}
